import { Component, OnDestroy, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-activate-client',
  templateUrl: './activate-client.component.html',
  styleUrls: ['./activate-client.component.scss'],
})
export class ActivateClientComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
  ) {}

  ngOnInit(): void {
    // Redirigir al registro ya que ahora se usa código de activación
    this.router.navigate(['/register']);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
